const ON_OFF = {
  OFF: [false, 'Tắt'],
  ON: [true, 'Bật'],
};
export default ON_OFF;
